import { render, staticRenderFns } from "./Documentacao.vue?vue&type=template&id=bf85f2b8&scoped=true"
import script from "./Documentacao.vue?vue&type=script&lang=js"
export * from "./Documentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf85f2b8",
  null
  
)

export default component.exports